/**
 * initialize event listener for quantity modifier button
 */
import {storeDataInLocalStorage} from "../../_common/localStorage"
import {showAlertAndDisplayText} from "../utils/alertUtils";
import {createAnalyticsEvent, getAnalyticsProxy, getAnalyticsV2Proxy} from "../utils/analyticsUtils";
export const pTiles = (function () {
  'use strict';

  var init = function () {
    // qty btns
    var qtyBtnSet = document.querySelectorAll(".product-tile__switch-group--js");
    // add btns
    var addBtns = document.querySelectorAll(".product-tile__action-btn--add-js");
    // wishlist btns
    var wishlistBtns = document.querySelectorAll(".product-tile__wishlist-btn");
    // report missing image links
    var reportMissingImageLinks = document.querySelectorAll(".product-tile__report-missing-image");

    /**
     * event listener for handling decrease quantity button click
     * @param {*} e event
     */
    var decreaseBuyQty = function (e) {
      var siblingField = e.currentTarget.parentElement.querySelector('.product-tile__qty-field--js');

      var fieldVal = parseInt(siblingField.value, 10);

      if (isNaN(fieldVal)) {
        siblingField.value = 1;
      }

      if (fieldVal > 1) {
        siblingField.value = fieldVal - 1;
      }
    };


    /**
     * event listener for handling increase quantity button click
     * @param {*} e event
     */
    var increaseBuyQty = function (e) {
      var siblingField = e.currentTarget.parentElement.querySelector('.product-tile__qty-field--js');

      var fieldVal = parseInt(siblingField.value, 10);

      if (isNaN(fieldVal)) {
        siblingField.value = 1;
      }

      if (fieldVal <= 29999) {
        siblingField.value = fieldVal + 1;
      }
    };

    /**
     * event listener to handle add product button click
     * @param {*} e event
     */
    var handleProductAdd = function (e) {
      var self = e.currentTarget;

      self.setAttribute( 'disabled', '' );
      self.classList.add('product-tile__action-btn--loading');

      // simulating error and succes state
      var btnState;
      if (Math.random () < 0.5) {
        btnState = "product-tile__action-btn--success";
      }
      else {
        btnState = "product-tile__action-btn--error";
      }

      // timeout to reenable button and remove the disbaled state
      setTimeout(function() {
        self.classList.remove('product-tile__action-btn--loading');
        self.classList.add( btnState);

        setTimeout(function() {
          self.classList.remove(btnState);
          self.removeAttribute('disabled');
        }, 1000);
      }, 2000);

    };



    /**
     * onclick event listener for wishlist button
     * @param {*} e event
     */
    var handleWishlistBtn = function (e) {
      var self = e.currentTarget;
      addOrRemoveOnWishlist(self);
      toggleWishlistBtn(self);
    };

    function showAlertDialog() {
      showAlertAndDisplayText(
          document.querySelector(".product-listing__product-grid .alert-dialog"),
          "Thank you for reporting this missing image",
          "Our team will work to update this soon"
      )
    }

    function removeReportLink(productCode) {
      const reportMissingImageLinks = document.querySelectorAll(`.product-tile__report-missing-image-${productCode}`);
      for (i = 0; i < reportMissingImageLinks.length; i ++) {
        reportMissingImageLinks[i].remove()
      }
    }
    function showReportedMessage(productCode) {
      const reportMissingMessages = document.querySelectorAll(`.product-tile__report-missing-message-${productCode}`);
      for (i = 0; i < reportMissingMessages.length; i ++) {
        reportMissingMessages[i].classList.remove("product-tile__report-missing-message__hidden")
      }
    }

    /**
     * onclick event listener for report missing image link
     * @param {*} e event
     */
    var handleReportMissingImage = function (e) {
      e.preventDefault();
      var self = e.currentTarget;

      const {productCode, productDescription} = self.dataset;

      showAlertDialog();
      removeReportLink(productCode);
      dispatchReportProductImage(productCode, productDescription);
      storeDataInLocalStorage(`missing-image-reported-${productCode}`, "true");
      showReportedMessage(productCode);
    };

    function dispatchReportProductImage(productCode, productDescription) {
      let productName = productDescription;
      let action = "Submit";
      let reportType = "missing image";

      const event = createAnalyticsEvent("reportProductImage", {
        source: "WEB",
        action,
        reportType,
        productCode,
        productName
      })

      getAnalyticsV2Proxy().push(event);
      getAnalyticsProxy().push(event);
    }

    const addOrRemoveOnWishlist = wishlistBtn => {
      const productCode = wishlistBtn.dataset.productCode;
      if (window.reece && window.reece.wishlist && window.reece.wishlist.updateProductInWishlist) {
        window.reece.wishlist.updateProductInWishlist(productCode)
      }
    };

    const toggleWishlistBtn = wishlistBtn => {
      const toggled = wishlistBtn.classList.contains("product-tile__wishlist-btn--added");

      if (toggled) {
        wishlistBtn.classList.remove("product-tile__wishlist-btn--added");
      }
      else {
        wishlistBtn.classList.add("product-tile__wishlist-btn--added");
      }
    };

    const markIfAlreadyInWishlist = wishlistBtn => {
      const productCode = wishlistBtn.dataset.productCode;
      if (window.reece && window.reece.wishlist && window.reece.wishlist.isProductInWishlist
        && window.reece.wishlist.isProductInWishlist(productCode)) {
        toggleWishlistBtn(wishlistBtn);
      }
    }


    // attach the event listeners
    var i;

    // qty buttons event listener
    for (i = 0; i < qtyBtnSet.length; i ++) {
      qtyBtnSet[i].querySelector(".product-tile__qty-switch--js-dec").onclick = decreaseBuyQty;
      qtyBtnSet[i].querySelector(".product-tile__qty-switch--js-inc").onclick = increaseBuyQty;
    }

    // assign event listener to the button
    for (i = 0; i < addBtns.length; i++) {
      addBtns[i].onclick = handleProductAdd;
    }

    for (i = 0; i < wishlistBtns.length; i ++) {

      wishlistBtns[i].onclick = handleWishlistBtn;
      markIfAlreadyInWishlist(wishlistBtns[i]);
    }

    for (i = 0; i < reportMissingImageLinks.length; i ++) {
      reportMissingImageLinks[i].onclick = handleReportMissingImage;
    }

  };

  return {
    init: init
  };

});




// WEBPACK FOOTER //
// ./javascript/product-search-page/raw-from-relab/product-tile.js